module.exports = __webpack_public_path__ + "img/img1.72c612c4.jpg";